import { AbstractControl, ValidatorFn } from '@angular/forms';

export function atLeastOneRequiredValidator(field1: string, field2: string): ValidatorFn {
    return (formGroup: AbstractControl): {[key: string]: any} | null => {
        const control1 = formGroup.get(field1);
        const control2 = formGroup.get(field2);

        if (!control1 || !control2) return null;

        const hasValue1 = !!control1.value?.trim();
        const hasValue2 = !!control2.value?.trim();

        return hasValue1 || hasValue2 ? null : { atLeastOneRequired: true };
    };
}
